import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken, setToken } from '@/utils/auth' // getToken from cookie
import { getUserInfoFromPC } from '@/utils/utilsOnlyForPC'
NProgress.configure({ showSpinner: false })// NProgress Configuration
const config = require('@/_app/' + process.env.PROJECT + '/src/config/index').default
// permissiom judge function
// function hasPermission(roles, permissionRoles) {
//   if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
//   if (!permissionRoles) return true
//   return roles.some(role => permissionRoles.indexOf(role) >= 0)
// }
function firstPath(menus) {
  let path = ''
  const firstMenus = menus[0]
  if (!firstMenus.children || firstMenus.children && firstMenus.children.length === 0) {
    if (firstMenus.configKey) {
      path = '/config/' + encodeURIComponent(firstMenus.configKey)
    } else {
      path = firstMenus.path
    }
  } else {
    firstPath(firstMenus.children)
  }
  return path
}
if (config.withoutLogin) {
    let userInfo = getUserInfoFromPC();
    setToken(userInfo.token || '8c45a74a0c9249e6a3d983f5717f5280')
    store.commit('SET_TOKEN', userInfo.token || '8c45a74a0c9249e6a3d983f5717f5280')
    // setToken('00ce28310b0244a28b48a50952ae91ad')
    // store.commit('SET_TOKEN','00ce28310b0244a28b48a50952ae91ad')
} else {
    const whiteList = ['/login', '/authredirect', '/reset-password']// no redirect whitelist

    router.beforeEach((to, from, next) => {
        NProgress.start() // start progress bar
        if (getToken()) { // determine if there has token
            /* has token*/
            if (to.path === '/login') {
                next({ path: '/' })
                NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
            } else {
                if (store.getters.userId.length === 0) { // 判断当前用户是否已拉取完user_info信息
                    store.dispatch('GetUserInfo').then(res => { // 拉取user_info
                        let menus = []
                        let path = ''
                        let locationPath = ''
                        if (process.env.PROJECT === 'outlet') {
                            menus = res.data.menus
                        }
                        const roles = res.data.roles // note: roles must be a array! such as: ['editor','develop']
                        store.dispatch('GenerateRoutes', { roles }).then(() => { // 根据roles权限生成可访问的路由表
                            if (menus.length > 0) {
                                locationPath = window.location.hash.split('#')[1]
                                path = firstPath(menus)
                            }
                            if (path && locationPath !== '/login') {
                                path = locationPath
                                next({ path: path })
                            } else {
                                // router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
                                // next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                                if (process.env.PROJECT === 'wwka' && from.path === '/login') {
                                    next({
                                        path: '/dashboard',
                                        replace: true
                                    })
                                } else {
                                    next({ ...to, replace: true })
                                }
                            }
                        })
                    }).catch((error) => {
                        store.dispatch('FedLogOut').then(() => {
                            if (error === 'error') {
                                Message.error('登陆失效, 请重新登陆')
                            } else {
                                Message.error(error)
                            }
                            next({ path: '/login' })
                            NProgress.done()
                        })
                    })
                } else {
                    // if (process.env.PROJECT === 'wwka' && to.path === '/dashboard') {
                    //     next({
                    //         path: '/config/%2Ftemplate%2Fmodule%2Fwantwant%2Fsale%2Fsystem_sale_list.json'
                    //     })
                    //     NProgress.done()
                    // } else {
                        next()
                    // }

                    // // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
                    // if (hasPermission(store.getters.roles, to.meta.roles)) {
                    //   next()//
                    // } else {
                    //   next({ path: '/401', replace: true, query: { noGoBack: true }})
                    // }
                    // 可删 ↑
                }
            }
        } else {
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
                next()
            } else {
                next('/login') // 否则全部重定向到登录页
                NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
            }
        }
    })

    router.afterEach(() => {

        NProgress.done() // finish progress bar
    })
}




// WEBPACK FOOTER //
// ./src/permission.js